export class ImgSrcConstants {
    public static exportImgUrl = 'src/app/customerservice/templates/template1/themes/default/images/';
}


// WEBPACK FOOTER //
// ./src/app/common/constants/imgsrc.constants.ts